module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAAFVBMVEUAAAC8vLy4uLi3t7e4uLi4uLi3t7erM5w4AAAAB3RSTlMAIkRVd4iZZZcICgAAAE9JREFUCB0FwbENwgAMADAHkT0d2hkBF3ABqjggHXJAl/5/AjYsIOaawlriIBpZsj5e0dL9+dU2htPm9ns4pbddyyoRLRpZrCUOxFxTYMEf2DMIcCy4z9oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/delete-tag.png
// module id = 94
// module chunks = 0